import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import { cleanCalculationServices } from 'services/CalculationServices/cleanCalculationsServices';

export class CleanCalculationsStore {
  cleanCalculation: any = null;
  roomCleanCalculations: any[] = [];
  dateCleanCalculations: any = {};
  isLoading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  fetchCleanCalculation = async (jobId: string) => {
    this.isLoading = true;
    try {
      const response = await cleanCalculationServices.getCleanCalculationForJob(jobId);

      runInAction(() => {
        if (response.success) {
          this.cleanCalculation = response.data;
        } else {
          this.cleanCalculation = null;
          // Don't show error for first job in room (no clean calculation needed)
          if (response.message !== 'No clean calculation needed for first job in room') {
            toast.error('Failed to fetch clean calculation');
          }
        }
      });
    } catch (error) {
      runInAction(() => {
        this.cleanCalculation = null;
        toast.error('Error fetching clean calculation');
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };

  fetchRoomCleanCalculations = async (room: string, date?: string) => {
    this.isLoading = true;
    try {
      const response = await cleanCalculationServices.getCleanCalculationsForRoom(room, date);

      runInAction(() => {
        if (response.success) {
          this.roomCleanCalculations = response.data;
        } else {
          this.roomCleanCalculations = [];
          toast.error('Failed to fetch room clean calculations');
        }
      });
    } catch (error) {
      runInAction(() => {
        this.roomCleanCalculations = [];
        toast.error('Error fetching room clean calculations');
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };

  fetchDateCleanCalculations = async (date: string) => {
    this.isLoading = true;
    try {
      const response = await cleanCalculationServices.getCleanCalculationsForDate(date);

      runInAction(() => {
        if (response.success) {
          this.dateCleanCalculations = response.data;
        } else {
          this.dateCleanCalculations = {};
          toast.error('Failed to fetch date clean calculations');
        }
      });
    } catch (error) {
      runInAction(() => {
        this.dateCleanCalculations = {};
        toast.error('Error fetching date clean calculations');
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };

  updateCleanCalculation = async (cleanCalcId: number, data: any) => {
    this.isLoading = true;
    try {
      const response = await cleanCalculationServices.updateCleanCalculation(cleanCalcId, data);

      runInAction(() => {
        if (response.success) {
          this.cleanCalculation = response.data;
          toast.success('Clean calculation updated successfully');
        } else {
          toast.error('Failed to update clean calculation');
        }
      });
    } catch (error) {
      runInAction(() => {
        toast.error('Error updating clean calculation');
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };

  // Reset store data
  reset = () => {
    this.cleanCalculation = null;
    this.roomCleanCalculations = [];
    this.dateCleanCalculations = {};
    this.isLoading = false;
  };
}
